var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"d-flex justify-space-between py-3 px-3 pa-lg-5 primary lighten-5",attrs:{"fixed":""}},[_vm._t("actions")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }